import React, { type FunctionComponent, Fragment } from 'react'
import { Breadcrumb } from '@retailer-platform/shared-components'
import { useDomainMessage } from 'domains/collections/utils/domain/intl'
import { type DashRouteComponentProps } from 'legacy/dash-components/dash-route/utils/dashRoute.types'
import DocumentTitle from 'legacy/components/DocumentTitle'
import { CollectionsView } from 'domains/collections/components/collections-view/CollectionsView'
import { collectionsAdminRoutingConfig } from 'domains/collections/utils/collectionsRoutingConfig'
import { navCollectionsAdminRoutingConfig } from 'domains/collections/utils/navCollectionsRoutingConfig'
import { useDomainScopedPathname } from 'domains/collections/utils/domain/routing'

interface Props
  extends DashRouteComponentProps<{
    collectionId: string
  }> {}

export const NavCollectionsAdminViewPage: FunctionComponent<Props> = ({ match }) => {
  const { collectionId } = match.params

  const rootText = useDomainMessage('navCollectionsDomain.title')
  const listPath = useDomainScopedPathname(navCollectionsAdminRoutingConfig.list)

  const baseBreadcrumbs = <Breadcrumb path={listPath}>{rootText}</Breadcrumb>

  return (
    <Fragment>
      <DocumentTitle titleId="collectionsDomain.navigationCollections.title" />

      <CollectionsView
        baseBreadcrumbs={baseBreadcrumbs}
        routingConfig={collectionsAdminRoutingConfig}
        collectionId={collectionId}
        retailerId={''}
      />
    </Fragment>
  )
}
